import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Container = styled.div`
  display: none;

  padding-block: 20px 40px;
  ${theme.breakpoints.up("tablet")} {
    display: block;
  }
`;
